const PIXEL_ID = '772523175496959';

/**
 * Generate a unique event ID suitable for CAPI deduplication.
 * The same ID must be sent by both the browser pixel and the backend CAPI call
 * for the same conversion. Meta uses it to deduplicate the two signals.
 */
export function generateEventId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * Re-initialise the Meta Pixel with known user identifiers.
 * Meta hashes em/ph automatically (SHA-256) when Advanced Matching is enabled.
 * Safe to call after login or signup — calling fbq('init') again enriches the
 * current session without firing a duplicate PageView.
 */
export function initPixelWithUser(email?: string, phone?: string) {
  if (typeof window === 'undefined' || !window.fbq) return;
  const userData: Record<string, string> = {};
  if (email) userData.em = email.toLowerCase().trim();
  if (phone) userData.ph = phone.replace(/\D/g, '');
  if (Object.keys(userData).length === 0) return;
  window.fbq('init', PIXEL_ID, userData);
}

/**
 * Fire a tracked pixel event.
 * Pass an eventId when the same event is also sent via the backend CAPI endpoint
 * so Meta can deduplicate the two signals and avoid double-counting.
 */
export function trackPixelEvent(
  event: string,
  params?: Record<string, any>,
  eventId?: string,
) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, { ...params }, eventId ? { eventID: eventId } : undefined);
}
